import { Helmet } from 'react-helmet-async';
import { useState, useCallback, useEffect } from 'react';
import { io } from 'socket.io-client';

// @mui
import {
  Card,
  Table,
  Stack,
  Paper,
  Button,
  Popover,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  IconButton,
  TableContainer,
  CircularProgress,
  Pagination,
  Select,
  FormControl,
  InputLabel,
  FormGroup,
  Checkbox,
  FormControlLabel,
  Grid
} from '@mui/material';

// cambios realizados para la actividad

import CustomModal from '../components/modal/CustomModal';

import FormEditTicket from '../components/forms/ticketForms/editTicket'
import { formatoFecha, formatoFechaAmFm } from '../context/DateInstance';

// components
import Label from '../components/label';
import Iconify from '../components/iconify';
// sections
// mock


import { UserListHead, UserListToolbar } from '../sections/@dashboard/user';
// hooks
import { useAxios } from '../context/AxiosHookContext';
import { useAuth } from '../context/AuthContext';
// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: '', label: 'Num. Solicitud', alignRight: false },
  { id: '', label: 'Solicitante', alignRight: false },
  { id: '', label: 'Ext', alignRight: false },
  { id: '', label: 'Descripción de la solicitud', alignRight: false },
  { id: '', label: 'Fecha del evento', alignRight: false },
  { id: '', label: 'Tipo de soporte', alignRight: false },
  { id: '', label: 'Estado', alignRight: false },
  { id: '', label: 'Técnico asignado', alignRight: false },
  { id: '', label: 'Fecha de solicitud', alignRight: false },
  { id: '' },
];


const socket = io("ws://localhost:3001/ws", {
  autoConnect: false
});

// ----------------------------------------------------------------------
export default function UserPage() {

  const { currentUser } = useAuth();
  const [openModalActivities, setOpenModalActivities] = useState(false);
  const [filterName, setFilterName] = useState("");
  const [supportAssigned, setSupportAssigned] = useState(!currentUser.role.some(item => item === "Administrador"))
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1)
  const [loading, setLoading] = useState(false)
  const [ticketList, setActivitiesList] = useState([])
  const [valuesToEdit, setValuesToEdit] = useState({})
  const [selectedTypes, setSelectedTypes] = useState(["Created", "Assigned"])
  const [open, setOpen] = useState(null);
  const [seletedOrder, setSeletedOrder] = useState(true);

  const TICKETS_API = `/tickets?&page=${page}&size=${10}&status=${selectedTypes.length > 0 ? JSON.stringify(selectedTypes) : ''}${supportAssigned ? `&support_assigned=${currentUser._id}` : ''}${filterName ? `&filterName=${filterName}` : ''}&sortById=${seletedOrder} `
  const axios = useAxios();

  // Validación de permisos después de los hooks
  const hasAdminPermissions = currentUser?.role?.some(role => 
    ['Administrador Tickets', 'Soporte'].includes(role)
  );


  const handleOpenMenu = (event, values) => {
    setOpen(event.currentTarget);
    setValuesToEdit(values)
  };

  const handleDoubleClick = (values) => {
    setValuesToEdit(values)
    setOpenModalActivities(true)
  }


  const handleCloseMenu = () => {
    setOpen(null);
  };


  const getTickets = useCallback(async () => {
    try {
      setActivitiesList([])
      setLoading(true);
      const { data } = await axios.get(TICKETS_API);
      setActivitiesList(data?.data?.list || []);
      setTotalPages(data?.data?.total_pages || 1)


    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }, [axios, TICKETS_API, setActivitiesList, setLoading, filterName, seletedOrder]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };




  useEffect(() => {
    getTickets();
  }, [getTickets, page, selectedTypes, supportAssigned, filterName, seletedOrder])


  useEffect(() => {

    try {
      const ws = new WebSocket(process.env.REACT_APP_WS_URL);
    
      ws.onopen = (event) => {
        console.log("WebSocket connection opened:", event);
      };
    
      ws.onmessage = () => {
        getTickets();
      };
    
      ws.onclose = (event) => {
        console.log("WebSocket connection closed:", event);
      };
    
      ws.onerror = (error) => {
        console.error("WebSocket error:", error);
      };
    
    } catch (error) {
      console.error("WebSocket error in try-catch:", error);
    }

  }, [getTickets]);


  // Validación de permisos - si no tiene permisos, mostrar mensaje de acceso denegado
  if (!hasAdminPermissions) {
    return (
      <Container>
        <Typography variant="h4" sx={{ mb: 5 }}>
          Acceso Denegado
        </Typography>
        <Typography variant="body1">
          No tienes permisos para acceder a la administración de tickets.
        </Typography>
      </Container>
    );
  }

  return (
    <>

      <Helmet>
        <title>Manejo de tickets | {process.env.REACT_APP_APP_NAME}</title>
      </Helmet>

        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Listado de tickets
          </Typography>
          <Button onClick={() => { setOpenModalActivities(true); setValuesToEdit({}) }} variant="contained" startIcon={<Iconify icon="eva:plus-fill" />}>
            Crear tickets
          </Button>
        </Stack>

        <Card>

          <Grid container alignItems={"center"}>
            <Grid item>
              <FormControl sx={{ width: 250, m: 2 }}>
                <InputLabel
                  id="role-label"
                  sx={{ marginTop: '-0.4rem' }} // Ajusta el valor según sea necesario
                >
                  Estados de tickets
                </InputLabel>
                <Select
                  labelId="role-label"
                  id="role"
                  multiple
                  value={selectedTypes}
                  onChange={(e) => { setSelectedTypes(e.target.value) }}
                  size="small"
                  label="Estados de tickets"
                >
                  <MenuItem value={"Created"}>Creado</MenuItem>
                  <MenuItem value={"Assigned"}>Asignado</MenuItem>
                  <MenuItem value={"Finished"}>Finalizado</MenuItem>
                </Select>
              </FormControl>

            </Grid>

            <UserListToolbar filterName={filterName} onFilterName={(e) => setFilterName(e.target.value)} />

            <Grid item>
              <FormGroup>
                <FormControlLabel control={<Checkbox value={supportAssigned} checked={supportAssigned} onChange={(e) => {
                  setSupportAssigned(Boolean(e.target.checked))
                }} />} label="Asignados a mi" />
              </FormGroup>
            </Grid>


            <Grid item>
              <FormControl sx={{ width: 250, m: 2 }}>
                <InputLabel
                  id="role-label"
                  sx={{ marginTop: '-0.4rem' }} // Ajusta el valor según sea necesario
                >
                  Ordenar tickets
                </InputLabel>
                <Select
                  labelId="role-label"
                  id="role"
                  value={seletedOrder}
                  onChange={(e) => { setSeletedOrder(Boolean(e.target.value)) }}
                  size="small"
                  label="Ordenar tickets"
                >
                  <MenuItem value={true}>Mas recientes</MenuItem>
                  <MenuItem value={false}>Mas antiguos</MenuItem>
                </Select>
              </FormControl>

            </Grid>
          </Grid>

          <TableContainer sx={{ minWidth: 800 }}>
            <Table>
              <UserListHead
                headLabel={TABLE_HEAD}
              />
              <TableBody>
                {ticketList.length > 0 && ticketList.map((row) =>

                (
                  <TableRow hover key={row._id} tabIndex={-1} role="checkbox" sx={{ cursor: "pointer" }} onDoubleClick={() => handleDoubleClick(row)}>

                    <TableCell component="th" scope="row" padding="normal">
                      {`${row.departmentShortName || 'TIC'}-${row._id}`}
                    </TableCell>

                    <TableCell component="th" scope="row" padding="normal">
                      {`${row?.requester?.displayName || ''}${row?.requester?.department ? ` (${row?.requester?.department})` : ''}`}
                    </TableCell>

                    <TableCell align="left">
                      {`${row?.requester?.mobilePhone || 'N/A'}`}
                    </TableCell>


                    <TableCell align="left">
                      {`${row?.comment || 'N/A'}`}
                    </TableCell>

                    <TableCell align="left">
                      <Label color={'success'} sx={{ textTransform: "none" }}>
                        {formatoFechaAmFm(row?.eventDate || row.created_date)}
                      </Label>
                    </TableCell>

                    <TableCell align="left">
                      {row?.support_subtype_1?.displayName || "N/A"}
                    </TableCell>

                    <TableCell align="left">
                      {row.status === "Created" ? "Creado" : row.status === "Assigned" ? "Asignado" : "Finalizado"}
                    </TableCell>

                    <TableCell align="left">
                      {
                        row?.support_assigned?.displayName || 'N/A'
                      }
                    </TableCell>

                    <TableCell align="left">
                      <Label color={'success'} sx={{ textTransform: "none" }}>
                        {formatoFecha(row.created_date)}
                      </Label>
                    </TableCell>

                    <TableCell align="right">
                      <IconButton size="large" color="inherit" onClick={(e) => handleOpenMenu(e, row)}>
                        <Iconify icon={'eva:more-vertical-fill'} />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>

              {
                loading === true &&
                <TableBody>
                  <TableRow>
                    <TableCell align="center" colSpan={9} sx={{ py: 3 }}>
                      <Paper
                        sx={{
                          textAlign: 'center',
                        }}
                      >

                        <CircularProgress size={"30px"} sx={{ color: "#aa9e97", marginRight: "auto", marginLeft: "auto" }} />

                      </Paper>
                    </TableCell>
                  </TableRow>
                </TableBody>
              }

              {
                (ticketList.length === 0 && loading === false) &&
                <TableBody>
                  <TableRow>
                    <TableCell align="center" colSpan={9} sx={{ py: 3 }}>
                      <Paper
                        sx={{
                          textAlign: 'center',
                        }}
                      >

                        <Typography variant="h6" paragraph>
                          Sin resultados
                        </Typography>

                        <Typography variant="body2">
                          No se encontraron resultados
                          <br /> Intente con otra búsqueda.
                        </Typography>
                      </Paper>
                    </TableCell>
                  </TableRow>
                </TableBody>
              }

            </Table>
          </TableContainer>

          <Pagination
            count={totalPages}
            page={page}
            onChange={handleChangePage}

            sx={{ float: "right", margin: 2, color: "#ffe7d9" }}
          />

        </Card>

      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            p: 1,
            width: 160,
            '& .MuiMenuItem-root': {
              px: 1,
              typography: 'body2',
              borderRadius: 0.75,
            },
          },
        }}
      >
        <MenuItem onClick={() => { setOpenModalActivities(true); setOpen(null) }} >
          <Iconify icon={'eva:edit-fill'} sx={{ mr: 2 }} />
          Editar
        </MenuItem>

      </Popover>


      <CustomModal
        open={openModalActivities}
        modalStyle={{ maxWidth: 800, minWidth: 440,maxHeight:700,overflowX:"auto" }}
        title={"Formulario de tickets de soporte"}
      >
        <FormEditTicket
          onClose={() => setOpenModalActivities(false)}
          getValues={() => {
            getTickets();
            setOpenModalActivities(false);
            setValuesToEdit({});
            setOpen(null);
          }}
          valuesToEdit={valuesToEdit}
        />
      </CustomModal>
    </>
  );
}
